<script lang="ts">
  import WorkspaceLayout from "../WorkspaceLayout.svelte";
  import KBSectionNavigation from "$components/knowledge-base/KnowledgeBaseNavigation/KBSectionNavigation.svelte";
  import {
    community,
    communitySlug,
    docsWidgetFlag,
    docsWidgetTeamOnlyFlag,
    isDocumentsEnabled,
  } from "$stores/community";
  import { getStores } from "$stores";
  import { onDestroy, onMount } from "svelte";
  import { isTeamMember } from "$stores/permissions";
  import { browser } from "$app/environment";
  import { setupWidget } from "$utils/widget";

  export let data;

  const { docs } = getStores();

  // $: docs.periodicallySync(data.communitySlug);
  $: docs.update(data.folders);

  // if members are not fetched, fetch them, so they can be accessed in the docs
  onMount(() => {
    if ($community.members.length === 0) {
      community.fetchMembers();
    }

    if ($docsWidgetFlag && (!$docsWidgetTeamOnlyFlag || $isTeamMember)) {
      setupWidget($communitySlug);
    }
  });

  onDestroy(() => {
    // hide the iframe on destroy
    if (browser) {
      window.ov?.hide();
    }
  });
</script>

<WorkspaceLayout showSidePanel>
  <svelte:fragment slot="sidebar">
    {#if $isDocumentsEnabled}
      <KBSectionNavigation {docs} />
    {/if}
  </svelte:fragment>

  <slot />
</WorkspaceLayout>
